import { render, staticRenderFns } from "./_base-panelWithHeader.vue?vue&type=template&id=14ea420b&scoped=true&"
import script from "./_base-panelWithHeader.vue?vue&type=script&lang=js&"
export * from "./_base-panelWithHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea420b",
  null
  
)

export default component.exports